const sizes = {
  'xs': {
    height: 4,
    width: 4,
  },
  'sm': {
    height: 8,
    width: 8,
  },
  'md': {
    height: 16,
    width: 16,
  },
  'lg': {
    height: 20,
    width: 20,
  },
  'xl': {
    height: 24,
    width: 24,
  },
  '2xl': {
    height: 32,
    width: 32,
  },
};

export default { sizes };
